import init, { JsWasmApp, wasmVersion } from "../pkg/ds_wasm";
import { DemoController } from "./controller";
import { createUi, initDock, initTabs } from "./dom";

const ui = createUi();
const controller = new DemoController(ui, init, JsWasmApp, wasmVersion);

controller.loadSamplePreset();
controller.attachGlobalHandlers();
controller.attachEventHandlers();
initTabs(ui);
initDock(ui);
void controller.initWasm();
